import { addListener } from 'rtk';
import {
  fetchDocument,
  fetchResource,
  documentCanceled,
  documentClosed,
  documentDirty,
  resourceDirty,
  addEventListener,
  removeEventListeners,
} from './actions';

import { selectDocument, selectRequest } from './selectors';

const subscribeEventListeners = (
  {
    payload: jsonapi,
    meta: {
      arg: { uuid, request, options = {} },
    },
  },
  { dispatch },
) => {
  // si dynamic===false, les autres paramètres sont ignorés
  // onUpdate est un booléen (mise à jour automatique initiée par le serveur
  // onDestroy === false on ne réagit pas au event destroy
  // === true on recharge le document si on détruit un des éléments (ou termine si on détruit data)
  // onNew === false on ne réagit pas au event new
  // === true ou [(contient le type pricipal)] recharge le document si un élément du type data est crée
  // === [ liste de types (contient le type pricipal)] recharge le document si un de ces type est crée
  const { action, type } = request;
  const {
    dynamic = true,
    onUpdate = true,
    onDestroy = true,
    onNew = action.verb !== 'find',
  } = options;

  if (!dynamic) return;

  const newToTrack = onNew ? { [type]: true } : {};
  if (Array.isArray(onNew)) {
    onNew.forEach((type) => (newToTrack[type] = true));
  }

  const { data, included } = jsonapi;
  const allResources = [data, included].flat().filter(Boolean);
  const isCollection = Array.isArray(data);
  if (onUpdate) {
    allResources
      .map(({ type, id }) =>
        addEventListener(
          uuid,
          { event: 'update', type, id },
          resourceDirty({ type, id }),
        ),
      )
      .forEach(dispatch);
  }
  const listeners = [];
  if (onDestroy && isCollection) {
    listeners.push(
      ...allResources.map(({ type, id }) =>
        addEventListener(
          uuid,
          { event: 'destroy', type, id },
          documentDirty(uuid),
        ),
      ),
    );
  }
  if (onDestroy && !isCollection) {
    listeners.push(
      ...[data].map(({ type, id }) =>
        addEventListener(
          uuid,
          { event: 'destroy', type, id },
          documentCanceled(uuid),
        ),
      ),
    );
  }
  if (onNew) {
    listeners.push(
      ...Object.keys(newToTrack).map((type) =>
        addEventListener(uuid, { event: 'new', type }, documentDirty(uuid)),
      ),
    );
  }
  listeners.forEach(dispatch);
};

addListener(
  fetchDocument.pending,
  (
    {
      meta: {
        arg: { uuid, request },
      },
    },
    { getState, dispatch },
  ) => {
    const jsonapi = selectDocument(getState());
    jsonapi && dispatch(removeEventListeners(uuid));
  },
  null,
);
addListener(fetchDocument.fulfilled, subscribeEventListeners, null);

addListener(
  [documentClosed, documentCanceled],
  ({ payload: { uuid } }, { dispatch }) => {
    dispatch(removeEventListeners(uuid));
  },
  null,
);

addListener(
  documentDirty,
  ({ payload: { uuid } }, { getState, dispatch }) => {
    const request = selectRequest(getState(), uuid);
    if (request) dispatch(fetchDocument({ uuid, request }));
  },
  null,
);

addListener(
  resourceDirty,
  ({ payload: identifier }, { getState, dispatch }) => {
    dispatch(fetchResource(identifier));
  },
  null,
);
